export interface DataTypeConfig {
  dataType: string
  label: string
  displayName: string
  enabled: boolean
}

export const DATA_TYPES: DataTypeConfig[] = [
  {
    dataType: 'LOCATION',
    label: 'Location',
    displayName: 'Location — Staged Records',
    enabled: true,
  },
  {
    dataType: 'SMOKER_RATES',
    label: 'Smoker Rates',
    displayName: 'Smoker Rates — Staged Records',
    enabled: true,
  },
  {
    dataType: 'SERVICE_AREAS',
    label: 'Service Areas',
    displayName: 'Service Areas — Staged Records',
    enabled: true,
  },
  {
    dataType: 'PLANS_AND_RATES',
    label: 'Plans & Rates',
    displayName: 'Plans & Rates — Staged Records',
    enabled: true,
  },
  {
    dataType: 'PLAN_BENEFITS',
    label: 'Plan Benefits',
    displayName: 'Plan Benefits — Staged Records',
    enabled: true,
  },
]

export const SUPPORTED_DATA_TYPES = new Set([
  'LOCATION',
  'SMOKER_RATES',
  'SERVICE_AREAS',
  'PLANS_AND_RATES',
  'PLAN_BENEFITS',
])

const dataTypeMap = new Map(DATA_TYPES.map((dt) => [dt.dataType, dt]))

export function getDataTypeLabel(dataType: string): string {
  return dataTypeMap.get(dataType)?.label ?? dataType
}

export function getDataTypeDisplayName(dataType: string): string {
  return dataTypeMap.get(dataType)?.displayName ?? dataType
}
